import { createFileRoute } from '@tanstack/react-router';

import { hasPermission } from '@nucleus-commerce/admin-kit/permissions';

import { PoliciesPage, policiesQueryOptions } from '@/features/policies';
import { storeQueryOptions } from '@/features/stores';

export const Route = createFileRoute('/_authed/_active/s/$storeId/settings/policies/')({
  staticData: { tours: ['settings.policies'] },
  loader: ({ context, params }) =>
    Promise.all([
      context.queryClient
        .query({ ...policiesQueryOptions(params.storeId), staleTime: 'static' })
        .catch(() => undefined),
      hasPermission(context.me.permissions, 'settings.read')
        ? context.queryClient
            .query({ ...storeQueryOptions(params.storeId), staleTime: 'static' })
            .catch(() => undefined)
        : undefined,
    ]),
  component: PoliciesPage,
});
